<ng-container *ngIf="!showError">
  <div class="container-fluid" *ngIf="customerInfo">
    <div class="detail-header">
      <div class="img-wrapper" *ngIf="whiteLabelInfo">
        <img [src]="whiteLabelInfo.logoUrl" alt="logo" class="logo" />
      </div>
      <h4>{{ altLogo }}</h4>
      <p>Please provide details to continue payment</p>
    </div>
    <div class="details-container">
      <form [formGroup]="clientDetailsForm">
        <div formGroupName="clientDetails">
          <div class="flex-container">
            <div>
              <input
                class="form-control form__control"
                id="CustomerFirstName"
                type="text"
                placeholder="First Name*"
                required
                formControlName="firstName"
              />
              <label for="CustomerFirstName" class="hidden-label">
                First Name*
              </label>
            </div>
            <div>
              <input
                class="form-control form__control"
                id="CustomerName"
                type="text"
                placeholder="Last Name*"
                formControlName="lastName"
                required
              />
              <label for="CustomerName" class="hidden-label">Last Name*</label>
            </div>
          </div>
          <div class="flex-container" *ngIf="customerInfo?.phoneNumberEnabled">
            <input
              class="form-control form__control"
              id="PhoneNumber"
              type="text"
              required
              formControlName="phone"
              placeholder="Phone Number*"
              appNumbersOnly
            />
            <label for="PhoneNumber" class="hidden-label">Phone Number</label>
          </div>
          <div class="flex-container">
            <input
              class="form-control form__control"
              id="email"
              type="text"
              required
              formControlName="email"
              placeholder="Email*"
            />
            <label for="Email" class="hidden-label">Email*</label>
          </div>
          <div class="flex-container">
            <div style="flex-basis: 18%">
              <select disabled>
                <option>{{ currency }}</option>
              </select>
            </div>
            <div style="flex-basis: 80%">
              <input
                class="form-control form__control"
                id="Amount"
                type="text"
                formControlName="amount"
                placeholder="Amount*"
                (keypress)="allowNumericKeys($event)"
              />
              <label for="Amount" class="hidden-label">Amount*</label>
            </div>
          </div>
          <div class="flex-container" *ngIf="customerInfo?.productNameEnabled">
            <input
              class="form-control form__control"
              id="productName"
              type="text"
              required
              formControlName="productName"
              placeholder="Product Name"
            />
            <label for="itemCode" class="hidden-label">Product Name</label>
          </div>
          <div class="flex-container" *ngIf="customerInfo?.itemCodeEnabled">
            <input
              class="form-control form__control"
              id="itemCode"
              type="text"
              required
              formControlName="itemCode"
              placeholder="Item Code"
            />
            <label for="itemCode" class="hidden-label">Item Code</label>
          </div>

          <div
            class="flex-container"
            style="margin-bottom: 1px"
            *ngIf="customerInfo?.payerAddressEnabled"
          >
            <textarea
              class="form-control form__control"
              id="address"
              type="address"
              formControlName="address"
              placeholder="Address"
            >
            </textarea>
            <label id="descr_label" for="narration" class="hidden-label">
              Address
            </label>
            <a id="conpasswordSpan1">
              <span
                id="conpasswordSpan"
                class="fa fa-exclamation-triangle in_form_icon"
              >
              </span>
            </a>
          </div>
          <div
            class="flex-container"
            style="margin-bottom: -50px"
            *ngIf="customerInfo?.productDescriptionEnabled"
          >
            <textarea
              class="form-control form__control"
              id="narration"
              type="narration"
              formControlName="descr"
              placeholder="Description"
            >
            </textarea>
            <label id="descr_label" for="narration" class="hidden-label">
              Description
            </label>
            <a id="conpasswordSpan1">
              <span
                id="conpasswordSpan"
                class="fa fa-exclamation-triangle in_form_icon"
              ></span>
            </a>
          </div>
        </div>
        <!-- Additional Fields -->
        <div class="mt_2">
          <div
            *ngFor="let field of extraFields; let i = index"
            class="flex-container"
            [formGroupName]="'additionalFields'"
          >
            <label class="hidden-label">{{ getFieldName(field) }}</label>
            <input
              type="text"
              class="form-control form__control"
              [placeholder]="transform(field)"
              [formControlName]="getFieldName(field)"
            />
          </div>
        </div>
        <div
          class="flex-container"
          style="margin-top: 20px; margin-bottom: -5px"
        >
          <!-- <p>
          How does
          <span
            [style.color]="'#ed1c25'"
            (click)="showClickToPayInformationModal.set(true)"
            >Click to pay</span
          >
          use my information?
          <span
            [style.color]="'#ed1c25'"
            (click)="showClickToPayInformationModal.set(true)"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </span>

          @if (showClickToPayInformationModal()) {
            <app-modal
              width="350px"
              modalType="primary"
              hideSubmitButton
              hideCancelButton
              (cancel)="showClickToPayInformationModal.set(false)"
            >

              <h2>Welcome to</h2>
              <h2 [style.color]="'#ed1c25'">Click to Pay</h2>
              <p>
                A fast, secure payment method supported by Mastercard and Visa
              </p>
              <img
                width="100%"
                src="../../../assets/images/mastercard-icons.png"
              />
              <ul>
                <li>Keep your information safe and secure</li>
                <li>Use it as merchants worldwide</li>
                <li>Set up once for hassle-free payments in the future</li>
              </ul>
            </app-modal>
          }
        </p> -->
          <button
            *ngIf="!isLoading"
            class="btn w-100 text-white form-btn no-margin-l no-margin-r"
            [style.background-color]="
              whiteLabelInfo ? whiteLabelInfo.brandColor : '#ed1c25'
            "
            type="submit"
            (click)="createPayment()"
          >
            <span>Continue to payment</span>
          </button>

          @if (isLoading) {
            <div class="form_button">
              <img src="" alt="" class="class fa fa-spinner fa-spin" />
              Loading...
            </div>
          }
        </div>
      </form>
      @if (!isPageLoading) {
        <div
          class="row justify-content-md-center"
          style="margin-bottom: 2%"
        ></div>
      }
    </div>
    <div class="footer mt-4" style="text-align: center; font-size: 12px">
      <app-footer style="margin-top: 6rem" [whiteLabelInfo]="whiteLabelInfo" />
    </div>
  </div>

  <!-- <app-modal
                          *ngIf="showModal"
                          [modalType]="'primary'"
                          [header]="header"
                          [subHeader]="errorMessage"
                          [buttonText]="'Close'"
                          [hideCancelButton]="true"
                          [width]="'10%'"
                          (cancel)="showModal = false"
                          [hideSubmitButton]="true"
                          (submit)="close()"
                          >
                        </app-modal> -->
  <app-error-dialog
    [visible]="showModal"
    [message]="errorMessage"
    (closed)="showModal = false"
  />
  @if (showError) {
    <app-not-found></app-not-found>
  }
</ng-container>
